export const getFixedMenuAppId = (type: string, pathname: string) => {
  const pathBox = pathname.split('/');
  const index = pathBox.indexOf(type);
  if (index - 1 < 0) return '';
  return pathBox[index - 1];
};

export default {};
